import React from 'react';
import { CriticalIcon, theme } from '@veeqo/ui';
import { getAlertFromKey } from '../../utils/getAlertFromKey';
import { ContentType, ErrorType } from '../../content';
import { AlertEl } from './styled';

export const Alert = ({
  contentType,
  errorKey,
}: {
  contentType: ContentType;
  errorKey?: ErrorType;
}) => {
  const { title, message, rightActions } = getAlertFromKey({ contentType, errorKey });

  return (
    <AlertEl
      variant="error"
      title={title}
      messageSlot={message}
      rightActionsSlot={rightActions}
      iconSlot={() => (
        <CriticalIcon style={{ color: theme.colors.secondary.red.dark }} width="24" height="24" />
      )}
    />
  );
};
